import { css } from '@emotion/react';
export const submitButtonStyles = css({
  marginLeft: 'auto',
  paddingRight: "var(--ds-space-100, 8px)",
  paddingLeft: "var(--ds-space-100, 8px)",
  marginRight: "var(--ds-space-075, 6px)"
});